import React from 'react'
import { CheckIcon } from '@heroicons/react/20/solid'
import { useAppContext } from '../libs/context'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

/**
 * Componente de Steps - Solo indicativo del progreso
 * NO permite navegación al hacer click, solo muestra en qué paso estás
 * La navegación se hace con los botones "Siguiente" y "Atrás" de cada paso
 */
const Steps = () => {
  const { stepsData } = useAppContext()

  return (
    <nav aria-label="Progress" className="bg-white rounded-lg shadow-sm">
      <ol
        role="list"
        className="border border-gray-200 rounded-lg divide-y divide-gray-200 md:flex md:divide-y-0"
      >
        {stepsData.map((step, stepIdx) => {
          return (
            <li key={step.name} className="relative md:flex-1 md:flex">
              {step.completed ? (
                // Paso completado - solo visual, no clicable
                <div className="flex items-center w-full">
                  <span className="px-6 py-4 flex items-center text-sm font-medium">
                    <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-green-600 rounded-full">
                      <CheckIcon
                        className="w-6 h-6 text-white"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="ml-4 text-sm font-medium text-gray-900">
                      {step.name}
                    </span>
                  </span>
                </div>
              ) : step.current ? (
                // Paso actual - resaltado
                <div
                  className="px-6 py-4 flex items-center text-sm font-medium bg-blue-50"
                  aria-current="step"
                >
                  <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-blue-dark rounded-full bg-white">
                    <span className="text-blue-dark font-bold">{step.id}</span>
                  </span>
                  <span className="ml-4 text-sm font-semibold text-blue-dark">
                    {step.name}
                  </span>
                </div>
              ) : (
                // Paso pendiente - gris
                <div className="flex items-center w-full">
                  <span className="px-6 py-4 flex items-center text-sm font-medium">
                    <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
                      <span className="text-gray-500">{step.id}</span>
                    </span>
                    <span className="ml-4 text-sm font-medium text-gray-500">
                      {step.name}
                    </span>
                  </span>
                </div>
              )}

              {/* Arrow separator for lg screens and up */}
              {stepIdx !== stepsData.length - 1 && (
                <div
                  className="hidden md:block absolute top-0 right-0 h-full w-5"
                  aria-hidden="true"
                >
                  <svg
                    className={classNames(
                      step.completed ? 'text-green-300' : 'text-gray-300'
                    )}
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                    style={{ height: '100%', width: '100%' }}
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vectorEffect="non-scaling-stroke"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Steps
